import React from 'react';



/**
 * DateDivider Component
 * Shows a date separator between messages
 *
 * @param {Object} props
 * @param {string|Date} props.date - Date to display
 * @param {boolean} props.sticky - Whether to make divider sticky on scroll
 */
const DateDivider = ({ date, sticky = true }) => {
  const formatDate = (date) => {
    if (!date) return '';

    const messageDate = new Date(date);
    const today = new Date();
    const yesterday = new Date(today);
    yesterday.setDate(yesterday.getDate() - 1);

    // Reset time parts for comparison
    today.setHours(0, 0, 0, 0);
    yesterday.setHours(0, 0, 0, 0);
    messageDate.setHours(0, 0, 0, 0);

    if (messageDate.getTime() === today.getTime()) {
      return 'Today';
    }

    if (messageDate.getTime() === yesterday.getTime()) {
      return 'Yesterday';
    }

    // Check if within this week
    const weekAgo = new Date(today);
    weekAgo.setDate(weekAgo.getDate() - 7);

    if (messageDate > weekAgo) {
      return messageDate.toLocaleDateString('en-US', { weekday: 'long' });
    }

    // Format as full date
    return messageDate.toLocaleDateString('en-US', {
      month: 'long',
      day: 'numeric',
      year: messageDate.getFullYear() !== today.getFullYear() ? 'numeric' : undefined
    });
  };

  return (
    <div className={`talk-date-divider ${sticky ? 'talk-date-divider-sticky' : ''}`}>
      <div className="talk-date-divider-line"></div>
      <div className="talk-date-divider-text">
        {formatDate(date)}
      </div>
      <div className="talk-date-divider-line"></div>
    </div>
  );
};

export default DateDivider;
